import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CONSTANTES } from '../../../../shared/constanst/url-scrolls-header';

@Component({
  selector: 'app-menu-principal',
  templateUrl: './menu-principal.component.html',
  styleUrl: './menu-principal.component.css'
})
export class MenuPrincipalComponent {
  rutaImagen: string = CONSTANTES.LOGO_BLANCO;

  constructor(private router: Router) {}

  irAPacientes() {
    this.router.navigate(['/pacientes']);
  }
}
